const r = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, n = {};
function e(t) {
  return n.hasOwnProperty(t) || (n[t] = r.test(t)), n[t];
}
export {
  e as default
};
//# sourceMappingURL=index.es58.js.map
